import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * Keeps a `matTooltip` on the same element quiet unless its text is cut off. Measured on hover,
 * because whether a label fits depends on the width it ends up with.
 */
@Directive({
  selector: '[appTooltipWhenTruncated]',
  standalone: false,
})
export class TooltipWhenTruncatedDirective {
  private readonly host: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly tooltip = inject(MatTooltip);

  @HostListener('mouseenter')
  protected onMouseEnter(): void {
    const element = this.host.nativeElement;
    this.tooltip.disabled = element.scrollWidth <= element.clientWidth;
  }
}
